import React from 'react';
import { processDecisionOptions } from '../utils/decisionColors';

/**
 * DecisionHandles Component
 * 
 * Renders colored branch buttons for decision nodes.
 * Each button corresponds to a decision option (e.g., Yes/No).
 * Click opens the add-connected-node menu; drag starts a connection (handled in parent).
 */
const DecisionHandles = ({
  task,
  screenPos,
  onDecisionBranchMouseDown,
}) => {
  const options = processDecisionOptions(task.options);
  
  return (
    <div
      data-task-id={task.id}
      className="handles-layer__decision-group"
      style={{
        left: screenPos.x,
        top: screenPos.y,
      }}
    >
      {options.map((option) => (
        <div
          key={`branch-${task.id}-${option.id}`}
          className="handles-layer__branch-btn"
          style={{ '--option-color': option.color }}
          onMouseDown={(e) => onDecisionBranchMouseDown?.(task, option, e)}
          title={option.label}
        >
          <span className="handles-layer__branch-label">
            {option.label.charAt(0)}
          </span>
        </div>
      ))}
    </div>
  );
};

export default DecisionHandles;
